import { useEffect, useState } from "react";
import { PleasewaitPopup } from "../../../components/PleasewaitPopup"
import useAuth from "../../../hook/useAuth";
import { useNavigate } from "react-router-dom";
import { getCourseCategories, post_Course } from "../../../services/Course";

export const AddCourse = () => {
    const { auth }: any = useAuth();
    const navigate = useNavigate();
    const [title, setTitle] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const [isPublished, setIsPublished] = useState<string>("No");
    const [courseCategoryId, setCourseCategoryId] = useState<number>(0);
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);

    useEffect(() => {
        getCourseCategories()
            .then((data) => {
                setCategoryOptions(data?.map((item: any) => {
                    return { value: item.id, label: item.name }
                }))

                setCourseCategoryId(data[0]?.id || 0)
            }).catch(error => {
                setCourseCategoryId(0);
                console.error(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setPleaseWaitPopup(true);

        await post_Course({
            courseCategoryId,
            title,
            description,
            isPublished: isPublished === "Yes" ? true : false,
            userId: auth?.id,
            createdAt: new Date().toLocaleString(),
            createdBy: auth?.givenname
        }, auth?.id)
            .then((response) => {
                setPleaseWaitPopup(false);
                navigate(-1);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
                console.error("Error:", error);
            });
    }


    return (
        <>
            <div className="w-full p-4 bg-white rounded-md">
                <h2 className={`text-lg font-semibold`}>Add Course</h2>

                <div className="mt-2 p-2">
                    <form onSubmit={(e) => handleSubmit(e)}>
                        <div className="w-full">

                            {/* Responsive Form Grid */}
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-6">
                                {/* First Column */}
                                <div className="space-y-4">
                                    <div>
                                        <label className="block text-xs font-medium text-[#667085]">Title</label>
                                        <input
                                            type="text"
                                            className="w-full px-[8px] py-[8px] border rounded-md border-[#D0D0D0] outline-none focus:border-[#167AC3] text-sm text-[#1D2939] bg-transparent"
                                            value={title}
                                            placeholder="Title"
                                            onChange={(e) => setTitle(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="block max-sm:hidden">
                                        <label className="block text-xs font-medium text-[#667085]">Description</label>
                                        <textarea
                                            rows={4}
                                            className="w-full px-[8px] py-[8px] border rounded-md border-[#D0D0D0] outline-none focus:border-[#167AC3] text-sm text-[#1D2939] bg-transparent"
                                            value={description}
                                            placeholder="Description"
                                            onChange={(e) => setDescription(e.target.value)}
                                        />
                                    </div>
                                </div>

                                {/* Second Column */}
                                <div className="space-y-4">
                                    <div>
                                        <label className="block text-xs font-medium text-[#667085]">Category</label>
                                        <select
                                            className={`w-full px-[8px] py-[8px] border rounded-md outline-none focus:border-[#167AC3] text-sm bg-transparent`}
                                            value={courseCategoryId}
                                            onChange={(e) => setCourseCategoryId(Number(e.target.value))}
                                        >
                                            {categoryOptions?.map((category: any) => (
                                                <option key={category.value} value={category.value}>
                                                    {category.label}
                                                </option>
                                            ))}

                                        </select>
                                    </div>

                                    <div>
                                        <label className="block text-xs font-medium text-[#667085]">Published</label>
                                        <select
                                            className={`w-full px-[8px] py-[8px] border rounded-md outline-none focus:border-[#167AC3] text-sm bg-transparent`}
                                            value={isPublished}
                                            onChange={(e) => setIsPublished(e.target.value)}
                                        >
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>

                                        </select>
                                    </div>


                                </div>


                            </div>
                            {/* Buttons */}
                            <div className="flex flex-col sm:flex-row gap-4 mt-6">
                                <button
                                    type="submit"
                                    className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                >
                                    Save
                                </button>
                                <button
                                    type="button"
                                    onClick={() => navigate(-1)}
                                    className="w-full sm:w-auto px-4 py-2 rounded bg-[#FFFFFF] text-primary cursor-pointer border border-primary"
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <PleasewaitPopup showPopup={pleaseWaitPopup} />
        </>
    )
}